export default "__VITE_ASSET__GpieBUEH__"